import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

// Presentational Component
const CategoryLink = ({ category, widgets }) => {
	return (
		<div className="category-link nav-link">
			<NavLink to={`/widgets/${category.name}`}>
				{category.name} Widgets
			</NavLink>
			<div className="route-links">
				{
					Object
						.keys(widgets)
						.filter(val => widgets[val].category === category.name) // Only show widgets from this category
						.sort()
						.map(widget => <NavLink key={widgets[widget].name} activeClassName="active-route" to={`/widgets/${category.name}/${widgets[widget].name}`}>{widgets[widget].name}</NavLink>)
				}
			</div>
		</div>
	);
};

CategoryLink.propTypes = {
	category: PropTypes.object.isRequired,
	widgets: PropTypes.object.isRequired,
};

export default CategoryLink;



// WEBPACK FOOTER //
// ./src/components/widgets/CategoryLink.js